import { render } from "./customerHistory.vue?vue&type=template&id=3993811a"
import script from "./customerHistory.vue?vue&type=script&lang=js"
export * from "./customerHistory.vue?vue&type=script&lang=js"

import "./customerHistory.vue?vue&type=style&index=0&id=3993811a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__